import { LegalLayout } from "./LegalLayout";
import { SOCLOSE } from "../../constants/soclose";

const PRODUCT = "3DPrintForge";

export function CookiesPage() {
  return (
    <LegalLayout title="Cookie Policy" updatedAt="2025-12-16">
      <p>
        This Cookie Policy explains how <strong>{SOCLOSE.name}</strong> ({SOCLOSE.uenLabel}) uses cookies and similar
        technologies on <strong>{PRODUCT}</strong>.
      </p>

      <h2>What is a cookie?</h2>
      <p>
        A cookie is a small text file placed on your device by your browser when you visit a website. Cookies allow the
        site to recognize your device between pages and visits.
      </p>

      <h2>Categories of cookies we use</h2>

      <h3>Essential</h3>
      <p>
        Strictly necessary for the service to work -- authentication session, CSRF protection, load balancing, language
        preference. These are always active; you cannot disable them without breaking the site.
      </p>

      <h3>Analytics (opt-in)</h3>
      <p>
        Help us understand how the service is used so we can improve it. We use privacy-friendly tools and only
        anonymized identifiers. Active only after you click "Accept all" or enable analytics in the cookie settings.
      </p>

      <h3>Marketing (opt-in)</h3>
      <p>Help us measure the performance of campaigns and personalize content. Used only with your explicit consent.</p>

      <h2>Managing your choices</h2>
      <p>
        On your first visit a banner lets you accept all, reject non-essential cookies, or customize per category. You
        can change your choice at any time by clearing the site's local storage or contacting us at{" "}
        <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a>.
      </p>

      <h2>Third-party cookies</h2>
      <p>
        Some pages embed third-party services (e.g. Stripe checkout, Google Fonts) that may set their own cookies. We
        only enable these third-party services when their function is essential or when you have given consent.
      </p>

      <h2>Retention</h2>
      <p>
        Essential cookies expire when you close the browser or after the session timeout. Analytics and marketing cookies
        expire after 13 months at most, in line with PDPA guidance.
      </p>

      <h2>Questions</h2>
      <p>Contact <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a>.</p>
    </LegalLayout>
  );
}
